const teachers = {
  teachers: "Enseignants",
  welcomeTeacherPersonalHome: "Bienvenue sur votre espace personnel",
  teacherNotSubscribedMessage:
    "Vous devez avoir au moins 10 élèves abonnés pour pouvoir utiliser cette fonctionnalité.",
  teacher: "Enseignant",
  teacherDetail: "Détails enseignant",
  teacherNotActivated: "Cet enseignant n'a pas activé son compte.",
  teacherWithColon: "Enseignant : ",
  teacherNoGradingSystem:
    "Avant de pouvoir créer un devoir, veuillez sélectionner le système de notation que vous souhaitez utiliser.",
  frenchGradingSystemLabel: "Français (/20)",
  germanGradingSystemLabel: "Allemand (/6)",
  selectGradingSystemTitle: "Sélectionner un système de notation",
  selectGradingSystemDescription:
    "Vous vous apprêtez à sélectionner le système de notation {gradingSystem} pour votre compte. Ce système de notation sera appliqué durant toute l’année scolaire.",
};

export default teachers;
